import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ClientSkuMapping } from '../../services/skuApi';

interface SkuListingState {
	clients: any[];
	selectedClientId: number | null;
	selectedStatus: string;
	mappings: ClientSkuMapping[];
	loading: boolean;
	/**
	 * Cross-city users (founders / type 4) can scope the client dropdown to
	 * a single city. null = "All cities". Ignored for users with a fixed
	 * city_id since the backend always returns their own city's clients.
	 */
	selectedCityId: number | null;
}

const initialState: SkuListingState = {
	clients: [],
	selectedClientId: null,
	selectedStatus: '',
	mappings: [],
	loading: false,
	selectedCityId: null,
};

const skuListingSlice = createSlice({
	name: 'skuListing',
	initialState,
	reducers: {
		setClients: (state, action: PayloadAction<any[]>) => {
			state.clients = action.payload;
		},
		setSelectedClientId: (state, action: PayloadAction<number | null>) => {
			state.selectedClientId = action.payload;
		},
		setSelectedStatus: (state, action: PayloadAction<string>) => {
			state.selectedStatus = action.payload;
		},
		setMappings: (state, action: PayloadAction<ClientSkuMapping[]>) => {
			state.mappings = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		clearMappings: state => {
			state.mappings = [];
		},
		setSelectedCityId: (state, action: PayloadAction<number | null>) => {
			state.selectedCityId = action.payload;
			// When the city changes, the previously-selected client may no
			// longer be in the visible list — clear it to avoid showing
			// mappings for a hidden client.
			state.selectedClientId = null;
			state.mappings = [];
		},
	},
});

export const {
	setClients,
	setSelectedClientId,
	setSelectedStatus,
	setMappings,
	setLoading,
	clearMappings,
	setSelectedCityId,
} = skuListingSlice.actions;
export default skuListingSlice.reducer;
